import React from "react";
import "pages/pickers/filter/filter.scss";
import { Field, Form } from "react-final-form";
import { FILTER_PICKERS_OPTIONS, PICKERS_TABS, PICKER_STATE_OPTIONS } from "utils/constants";
import useValidationSchema from "hooks/useValidationSchema";
import { FilterTypes } from "../types";
import { validationSchemaAR } from "./schemaAR";
import { useTranslation } from "react-i18next";
import "../i18n";
import DropdownFilter from "component/dropdownFilter/DropdownFilter";
import { Button, MultiSelectInput, TextInput } from "@pickit/pickit-components";
import classNames from "classnames";

export const FilterPickers: React.FC<FilterTypes> = ({
  onSubmit,
  filters,
  regions,
  testId,
  actualPage,
  setCollapseTable,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("global:filter")}
      testId={testId}
      collapseTable={setCollapseTable}
    >
      <div className="container-fluid display-filter">
        <div className="container-row">
          <div className="container-col-auto"></div>
          <div className="container-col">
            <div className="container-row">
              <Form
                onSubmit={(value) => {
                  onSubmit(value);
                }}
                initialValues={filters}
                validate={useValidationSchema(validationSchemaAR)}
              >
                {({ handleSubmit, form, invalid }) => (
                  <form
                    className="form-filter-transaction"
                    onSubmit={handleSubmit}
                  >
                    <div className="container-col-sm-3">
                      <Field
                        type="text"
                        name="name"
                        label={t("filterPickers:nameLabel")}
                        component={TextInput}
                        className="Admin-Pickers-input test"
                        placeholder={t("filterPickers:namePlaceholder")}
                        maxLength={50}
                        testId={`${testId}-name`}
                      />
                    </div>
                    <div className="container-col-sm-3">
                      <Field
                        type="text"
                        name="identificationNumber"
                        label={t("filterPickers:identifierLabel")}
                        component={TextInput}
                        className="Admin-Pickers-input"
                        placeholder={t("filterPickers:identifierPlaceholder")}
                        maxLength={8}
                        testId={`${testId}-identification-number`}
                      />
                    </div>
                    <div className="container-col-sm-3">
                      <Field
                        name="vehicleType"
                        label={t("filterPickers:vehicleLabel")}
                        placeholder={t("filterPickers:vehiclePlaceholder")}
                        testId={`${testId}-vehicle`}
                        options={FILTER_PICKERS_OPTIONS.map((o) => ({
                          ...o,
                          name: t(o.label),
                        }))}
                        keyProperty="value"
                      >
                        {(props: any) => <MultiSelectInput {...props} />}
                      </Field>
                    </div>
                    <div className="container-col-sm-3">
                      <Field
                        type="text"
                        name="email"
                        label={t("filterPickers:emailLabel")}
                        component={TextInput}
                        className="Admin-Pickers-input"
                        placeholder={t("filterPickers:emailPlaceholder")}
                        maxLength={250}
                        testId={`${testId}-email`}
                      />
                    </div>
                    <div className="container-col-sm-3">
                      <Field
                        name="regions"
                        placeholder={t("filterPickers:regionPlaceholder")}
                        options={regions}
                        testId={`${testId}-regions`}
                        label={t("filterPickers:regionLabel")}
                      >
                        {(props: any) => (
                          <MultiSelectInput
                            {...props}
                            labelAll={t("global:allF")}
                          />
                        )}
                      </Field>
                    </div>
                    {actualPage === PICKERS_TABS.pickers && (
                      <div className="container-col-sm-3">
                        <Field
                          name="status"
                          placeholder={t("filterPickers:statePlaceholder")}
                          options={PICKER_STATE_OPTIONS.map((o) => ({
                            ...o,
                            name: t(o.name),
                          }))}
                          testId={`${testId}-states`}
                          label={t("filterPickers:stateLabel")}
                        >
                          {(props: any) => <MultiSelectInput {...props} />}
                        </Field>
                      </div>
                    )}
                    <div
                      className={classNames("end", {
                        "container-col-sm-6": actualPage === "pickers",
                        "container-col-sm-9": actualPage === "pending",
                      })}
                    >
                      <Button
                        label={t("global:search")}
                        type="submit"
                        hierarchy="secondary"
                        iconName="search"
                        testId={`${testId}-search-button`}
                        disabled={invalid}
                      />
                    </div>
                  </form>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </DropdownFilter>
  );
};
